import type { GetStaticProps } from 'next';

import { fetchBlogPosts } from '../../utils/api/fetchStrapiData';
import NftDevelopmentPage from '../../views/nftDevelopmentPage';

export const getStaticProps: GetStaticProps = async () => {
  const data = await fetchBlogPosts();

  return {
    props: { blogPosts: data },
  };
};

export default NftDevelopmentPage;
